(() => {
  if (window.DRBONativeService) return;
  const init = () => {
    const root = document.querySelector('[data-drbo-native-service]');
    if (!root || document.querySelector('[data-drbo-configurator]')) return;
    const form = root.closest('form');
    const section = root.closest('[data-section-type="product"]');
    const row = root.querySelector('[data-service-plus-recommendation]');
    const toggle = row?.querySelector('[data-summary-extra-toggle]');
    if (!form || !section || !row || !toggle) return;
    const variants = JSON.parse(root.querySelector('[data-native-service-variants]').textContent);
    const extras = new Map();
    let busy = false;
    const currency = root.dataset.currency;
    const formatMoney = amount => new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency }).format(amount / 100);
    const serviceId = Number(row.dataset.id);
    const panel = root.querySelector('[data-native-pv-offer]');
    const panelQuantity = panel?.querySelector('[data-native-pv-quantity]');
    const status = root.querySelector('[data-native-service-status]');
    const mainButton = form.querySelector('.product-add-to-cart__button[type="submit"]');
    const detailsScope = root.closest('.shopify-section') || section;
    const renderSelectionDetails = items => {
      const selected = items.filter(item => Number(item.quantity) > 0);
      const quantity = selected.reduce((total, item) => total + Number(item.quantity), 0);
      const language = document.documentElement.lang.toLowerCase().split('-')[0];
      const productLabel = language === 'en' ? (selected.length === 1 ? 'product' : 'products') : language === 'nl' ? (selected.length === 1 ? 'product' : 'producten') : (selected.length === 1 ? 'Produkt' : 'Produkte');
      const quantityLabel = language === 'en' ? (quantity === 1 ? 'item' : 'items') : language === 'nl' ? 'st.' : 'Stk.';
      detailsScope.querySelectorAll('[data-drbo-native-summary]').forEach(summary => {
        summary.textContent = `${selected.length} ${productLabel} · ${quantity} ${quantityLabel}`;
        summary.hidden = selected.length === 0;
      });
      detailsScope.querySelectorAll('[data-drbo-native-details-list]').forEach(list => {
        const signature = JSON.stringify(selected.map(item => [item.id, item.title, item.image, item.quantity, item.isPrimary]));
        if (list.dataset.selection === signature) return;
        const fragment = document.createDocumentFragment();
        selected.forEach(item => {
          const entry = document.createElement('li');
          entry.className = `drbo-native-config-details__item${item.isPrimary ? ' drbo-native-config-details__item--primary' : ''}`;
          entry.dataset.variantId = String(item.id);
          const media = document.createElement(item.image ? 'img' : 'span');
          media.className = item.image ? 'drbo-native-config-details__image' : 'drbo-native-config-details__placeholder';
          if (item.image) {
            media.src = item.image;
            media.alt = '';
            media.width = 48;
            media.height = 48;
            media.loading = 'lazy';
          } else media.setAttribute('aria-hidden', 'true');
          const title = document.createElement('span');
          title.className = 'drbo-native-config-details__title';
          title.textContent = item.title;
          const meta = document.createElement('span');
          meta.className = 'drbo-native-config-details__meta';
          const amount = document.createElement('span');
          amount.className = 'drbo-native-config-details__quantity';
          amount.textContent = `× ${item.quantity}`;
          meta.appendChild(amount);
          entry.append(media, title, meta);
          fragment.appendChild(entry);
        });
        list.replaceChildren(fragment);
        list.dataset.selection = signature;
      });
    };
    const serviceItem = () => ({ id: serviceId, productId: Number(row.dataset.productId), quantity: 1, price: Number(row.dataset.price), comparePrice: Math.max(Number(row.dataset.price), Number(row.dataset.comparePrice || 0)), title: row.dataset.title, image: row.dataset.image, url: row.dataset.url, isService: true, isExtra: true, campaignEligible: root.dataset.serviceCampaignEligible === 'true', available: row.dataset.available !== 'false' });
    const panelItem = quantity => ({ id: Number(panel.dataset.id), productId: Number(panel.dataset.productId), quantity, price: Number(panel.dataset.price), comparePrice: Number(panel.dataset.price), title: panel.dataset.title, image: panel.dataset.image, url: panel.dataset.url, isExtra: true, campaignEligible: panel.dataset.campaignEligible === 'true', available: panel.dataset.available !== 'false' });
    const api = {
      productId: Number(root.dataset.productId), extras, state: null,
      refresh(emit = true) {
        const variant = variants.find(entry => String(entry.id) === String(form.elements.namedItem('id')?.value));
        const quantityField = form.elements.namedItem('quantity');
        const quantity = Number(quantityField?.value || section.querySelector('input[name="quantity"]')?.value || 1);
        const validQuantity = Number.isSafeInteger(quantity) && quantity > 0;
        const items = variant && validQuantity ? [{ id: variant.id, productId: api.productId, quantity, price: variant.price, comparePrice: Math.max(variant.price, Number(variant.compare_at_price || 0)), title: root.dataset.productTitle, image: variant.featured_image?.src || root.dataset.productImage, url: root.dataset.productUrl, isPrimary: true, available: variant.available }, ...extras.values()] : [];
        const total = items.reduce((amount, item) => amount + item.price * item.quantity, 0);
        const compareTotal = items.reduce((amount, item) => amount + Math.max(item.price, item.comparePrice || 0) * item.quantity, 0);
        api.state = { configuratorId: '', source: 'current_product', currency, items, total, compareTotal, rawTotal: total, appDiscount: 0, discountMessage: '', disabled: busy || !variant?.available || !validQuantity || items.some(item => item.available === false), recommendationContext: { offeredProductIds: [Number(row.dataset.productId), ...(panel ? [Number(panel.dataset.productId)] : [])] } };
        const selected = extras.has(serviceId);
        toggle.setAttribute('aria-pressed', String(selected));
        toggle.textContent = selected ? toggle.dataset.offerRemoveLabel : toggle.dataset.offerAddLabel;
        toggle.disabled = busy || (!selected && row.dataset.available === 'false');
        row.classList.toggle('is-added', selected);
        if (panelQuantity) {
          panelQuantity.disabled = busy || panel.dataset.available === 'false';
          panel.querySelector('[data-native-pv-unit-price]').textContent = formatMoney(Number(panel.dataset.price));
          panel.classList.toggle('is-added', Number(panelQuantity.value) > 0);
          const panelAmount = panel.querySelector('[data-native-pv-amount]');
          panelAmount.hidden = Number(panelQuantity.value) === 0;
          panel.querySelector('[data-native-pv-amount-value]').textContent = formatMoney(Number(panel.dataset.price) * Number(panelQuantity.value));
        }
        const totalLine = root.querySelector('[data-native-service-total]');
        totalLine.hidden = extras.size === 0;
        root.querySelector('[data-native-service-total-value]').textContent = formatMoney(total);
        if (mainButton) mainButton.disabled = api.state.disabled;
        section.querySelectorAll('.js-price [data-product-price]').forEach(element => {
          const text = formatMoney(total);
          if (element.textContent !== text) element.textContent = text;
          if (element.dataset.amount !== String(total)) element.dataset.amount = String(total);
        });
        section.querySelectorAll('.js-price [data-price-old]').forEach(element => {
          const text = compareTotal > total ? formatMoney(compareTotal) : '';
          if (element.textContent !== text) element.textContent = text;
          if (element.dataset.amount !== String(compareTotal)) element.dataset.amount = String(compareTotal);
        });
        section.querySelectorAll('.js-price').forEach(element => element.classList.toggle('price--on-sale', compareTotal > total));
        const selection = window.DRBOAcceleratedConfiguration?.buildSelection(api.state);
        renderSelectionDetails(items);
        if (selection) window.DRBOAcceleratedConfiguration.writeForm(form, selection);
        form.querySelectorAll('shopify-accelerated-checkout').forEach(element => { element.inert = api.state.disabled; });
        if (emit) document.dispatchEvent(new CustomEvent('drbo:native-service:update', { detail: api.state }));
        return api.state;
      },
      async purchase(checkout = false) {
        const state = api.refresh(false);
        if (state.disabled || busy) return;
        const formData = new FormData(form);
        const items = state.items.map(item => ({ id: item.id, quantity: item.quantity }));
        const properties = {};
        for (const [key, value] of formData) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) items[0].properties = properties;
        if (formData.get('selling_plan')) items[0].selling_plan = formData.get('selling_plan');
        busy = true;
        root.setAttribute('aria-busy', 'true');
        status.hidden = true;
        api.refresh();
        try {
          const route = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${route}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || root.dataset.purchaseError);
          if (checkout) window.location.assign(`${route}checkout`);
          else if (window.themeCore?.EventBus?.emit) window.themeCore.EventBus.emit('cart:drawer:refresh-and-open');
          else window.location.assign(`${route}cart`);
        } catch (error) {
          status.textContent = error.message || root.dataset.purchaseError;
          status.hidden = false;
        } finally {
          busy = false;
          root.removeAttribute('aria-busy');
          api.refresh();
        }
      }
    };
    toggle.addEventListener('click', () => {
      if (busy) return;
      if (extras.has(serviceId)) extras.delete(serviceId);
      else if (row.dataset.available !== 'false') extras.set(serviceId, serviceItem());
      api.refresh();
    });
    panelQuantity?.addEventListener('change', () => {
      const quantity = Number(panelQuantity.value);
      const panelId = Number(panel.dataset.id);
      if (Number.isSafeInteger(quantity) && quantity > 0 && panel.dataset.available === 'true') extras.set(panelId, panelItem(quantity));
      else extras.delete(panelId);
      api.refresh();
    });
    form.addEventListener('submit', event => {
      if (!extras.size) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      api.purchase(false);
    }, true);
    section.addEventListener('change', () => requestAnimationFrame(() => api.refresh()));
    if (window.themeCore?.EventBus?.listen) window.themeCore.EventBus.listen(`pdp:section-${section.dataset.sectionId}:change-variant`, () => requestAnimationFrame(() => api.refresh()));
    root.hidden = false;
    window.DRBONativeService = api;
    api.refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
